export enum EUserRoles {
  ADMIN = 'nexdos-app-admin',
  STAFF = 'nexdos-app-staff',
  PORTFOLIO_MANAGER = 'nexdos-app-portfolio-manager',
  PROFESSIONAL_CLIENT = 'nexdos-app-professional-client',
  SUITABLE_COUNTERPARTY = 'nexdos-app-suitable-counterparty'
}